import { FormSteps } from "@components";
import { IHealthRecord } from "@interfaces";
import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StepOne } from "./StepOne";
import dayjs from "dayjs";
import { STEP_FOUR, STEP_ONE, STEP_THREE, STEP_TWO } from "@configs";
import { StepTwo } from "./StepTwo";
import { StepThree } from "./StepThree";
import styled from "styled-components";
import { DividerLine } from "./Divider";
import { healthApi } from "@api";
import { Result } from "./Result";
import { useNotify } from "@utils";
import { useParams } from "react-router";
interface IProps {
  record?: IHealthRecord;
}
const initValue: IHealthRecord = {
  clinic_id: "",
  client_name: "",
  client_visit_date: dayjs().format(),
  client_phoneNumber: "",
  client_age: 0,
  client_region_id: "",
  client_township_id: "",
  client_gender: "",
  birth_spacing_parity: "",
  birth_spacing_user_type: "",
  birth_spacing_main_method_for_now: "",
  birth_spacing_iud_removal: "",
  birth_spacing_iud_removal_reason: "",
  birth_spacing_implant_removal: "",
  birth_spacing_implant_removal_reason: "",
  birth_spacing_insertion: "",
  birth_spacing_unfavorable_medical_condition: "",
  ccp_awareness: "",
  ccp_screening: "",
  ccp_screening_result: "",
  ccp_treatment: "",
  ccp_treatment_referred_site: "",
  ayfhs_sti: "",
  ayfhs_birth_spacing: "",
  ayfhs_rh_problem: "",
  gbv_awareness: "",
  gbv_hotline: "",
  disability: "Yes",
  seeing_disability: "",
  seeing_disability_level: "",
  walking_disability: "",
  walking_disability_level: "",
  concentration_disability: "",
  concentration_disability_level: "",
  self_care_disability: "",
  self_care_disability_level: "",
  communication_disability: "",
  communication_disability_level: "",
};
export const HealthRecordForm = memo(({ record }: IProps) => {
  const { t } = useTranslation();
  const [stepVal, setStepVal] = useState<number>(STEP_ONE);
  const { id } = useParams<{ id: string }>();
  const { success, error } = useNotify();

  const [healthData, setHealthData] = useState<IHealthRecord>(initValue);
  const steps = [
    {
      title: t("page.Client_Data_Collection"),
    },
    {
      title: t("page.RH_Services"),
    },
    {
      title: t("page.Client_Disability_Data_Form"),
    },
  ];
  useEffect(() => {
    if (record) {
      setHealthData(record);
    }
  }, [record]);
  const callback = async (data: IHealthRecord, step: number) => {
    if (step === STEP_FOUR) {
      try {
        if (id) {
          await healthApi.update(
            {
              ...healthData,
              ...data,
              client_visit_date: dayjs(healthData?.client_visit_date),
              client_age: Number(healthData?.client_age),
              clinic_id: healthData?.clinic_id,
            },
            id
          );
          await console.log({
            ...healthData,
            ...data,
            client_visit_date: dayjs(healthData?.client_visit_date),
            client_age: Number(healthData?.client_age),
          });
        } else {
          await healthApi.create({
            ...healthData,
            ...data,
            client_visit_date: dayjs(healthData?.client_visit_date),
            client_age: Number(healthData?.client_age),
            clinic_id: healthData?.clinic_id,
          });
          await console.log({
            ...healthData,
            ...data,
            client_visit_date: dayjs(healthData?.client_visit_date),
            client_age: Number(healthData?.client_age),
          });
          success(t("message.create.success"));
        }
      } catch (error: any) {
        console.log(new Error(error));
        error(t("message.create.fail"));
      }
    }
    await setHealthData({ ...healthData, ...data });
    await setStepVal(step);
  };

  return (
    <StyledForm>
      <FormSteps steps={steps} current={stepVal} />
      {stepVal === STEP_FOUR ? (
        <Result />
      ) : (
        <>
          <h3>{t("page.Client_Data_Collection")}</h3>
          {stepVal >= STEP_ONE && <StepOne callback={callback} data={healthData} />}
          <DividerLine />
          {stepVal >= STEP_TWO && (
            <>
              <StepTwo callback={callback} data={healthData} />
              <DividerLine />
            </>
          )}
          {stepVal >= STEP_THREE && <StepThree callback={callback} data={healthData} />}
        </>
      )}
    </StyledForm>
  );
});
const StyledForm = styled.section`
  h3 {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 40px;
  }
`;
